import { render, staticRenderFns } from "./SociodemoTab.vue?vue&type=template&id=f08cb364&"
import script from "./SociodemoTab.vue?vue&type=script&lang=js&"
export * from "./SociodemoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports